import { EditLink, HeadCell } from '@dfl/mui-admin-layout';
import { EstablishmentRowActions } from 'modules/client/establishment/components/EstablishmentRowActions';
import { ESTABLISHMENT_PERMISSIONS } from 'modules/client/establishment/constants/establishment.permissions';
import { IEstablishment } from 'modules/client/establishment/interfaces';
import { createdATColumn } from 'modules/common/constants';

export const establishmentNameColumn: HeadCell<IEstablishment> = {
  field: 'name',
  headerName: 'establishment:fields.name',
  disablePadding: false,
  renderCell: (name: string, data: IEstablishment) => <EditLink entityId={data._id as string}>{name}</EditLink>,
};

export const establishmentDescriptionColumn: HeadCell<IEstablishment> = {
  field: 'description',
  headerName: 'establishment:fields.description',
};

export const establishmentActionsColumn: HeadCell<IEstablishment> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: ESTABLISHMENT_PERMISSIONS.ESTABLISHMENT_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  component: EstablishmentRowActions,
};

export const establishmentColumns: Array<HeadCell<any>> = [
  establishmentNameColumn,
  establishmentDescriptionColumn,
  createdATColumn,
  establishmentActionsColumn,
];
